<template>
  <div  class="themeable">
    <myAside class="myAside" ref="myAside"></myAside>
    <div
      class="page"
      ref="page"
      :style="{marginLeft:menuMarginLeft,paddingTop:showpaddingTop}"
      :class="{showBreadMenu:showBreadMenu}"
    >
      <!-- <template v-for="(item,index) in alertData">
        <Alert
          style="text-align: center;position: absolute;z-index: 999999;top: 5px;left: 5px;right: 5px;"
          type="success"
          class="alertNotice"
          v-if="!ClosedIds.find(x => item.PlatformNoticeId == x)"
          :key="index"
        >
          <span style="color:#ff5858;font-weight:600;margin-right:10px;">{{item.NoticeTitle}}</span>
          <div v-html="item.NoticeContent" class="inlineInner"></div>
          <span style="color:#ff5858;cursor:pointer;">
            <Icon type="md-close" :size="16" @click="delNotice(item)" />
          </span>
        </Alert>
      </template> -->
      <!-- v-if="!ClosedIds.find(x => item.PlatformNoticeId == x)" -->
      <div class="top-tipcontainer" v-if="alertNotice.length > 0">
        <template v-for="(item, index) in alertNotice">
          <div
            banner
            class="text"
            :key="index"
            @click="jumpTo(item)"
            v-show="index === currentTextIndex"
          >
            <span style="color:#ff5858;font-weight:600;margin-right:10px;">{{item.NoticeTitle}}</span>
            <div v-html="item.NoticeContent" class="inlineInner"></div>
            <span class="tip-close">
              <Icon type="md-close" :size="16" @click="delNotice(item)" />
            </span>
          </div>
        </template>
      </div>
      <!-- 面包屑 -->
      <div slot="topMenu" class="topMenu themeable" v-if="showBreadMenu">
        <div class="reBtn" @click="back">
          <Icon custom="iconfont menu_arrowback" size="20" color="#44526E"></Icon>返回
        </div>
        <Breadcrumb class="bread" separator=">">
          <BreadcrumbItem
            :to="item.Url"
            v-for="item in breadData"
            :key="item.ElementId"
          >{{ typeof(item)=='string'?item:item.Name}}</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <!-- 三级菜单样式 -->
      <div slot="topParentMenu" class="topParentMenu themeable" v-if="!showBreadMenu&&currentMenuLen >= 3">
        <div class="reBtn">
          <Icon custom="iconfont menu_menunav" size="20" color="#44526E"></Icon>
          {{threeLevelMenu.Name}}
        </div>
        <Menu
          ref="topParentMenu"
          mode="horizontal"
          :active-name="currentMenuLen==4?ParentMenu:activeMenu"
        >
          <MenuItem
            v-for="item in threeLevelMenu.childs"
            :name="item.ElementId"
            :key="item.ElementId"
            @click.native="goToLink(item.Url)"
          >{{item.Name}}</MenuItem>
        </Menu>
      </div>
      <!-- 四级菜单样式 -->
      <div class="MidChildMenu" v-if="!showBreadMenu && currentMenuLen == 4">
        <Menu ref="MidChildMenu" mode="horizontal" :active-name="activeMenu">
          <MenuItem
            v-for="item in fourLevelMenu.childs"
            :name="item.ElementId"
            :key="item.ElementId"
            @click.native="goToLink(item.Url)"
          >{{item.Name}}</MenuItem>
        </Menu>
      </div>
      <router-view class="page-content router" ref="pageContent"></router-view>
    </div>
  </div>
</template>

<script>
import myAside from '../aside/aside.vue';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      subMens: [],
      threeLevelMenu: {},
      fourLevelMenu: {},
      breadData: [],
      activeMenu: '',
      hasNotice: true,
      data: [],
      alertData: [],
      alertNotice: [],
      ClosedIds: [],
      options:[
        {name:111},
        {name:112},
        {name:113},
        {name:114},
        {name:115}
      ],
      marginTop:0,
      currentTextIndex : 0,
    };
  },
  created () {
    this.$nextTick(() => {
      if (localStorage.getItem('ClosedIds')) {
        this.ClosedIds = JSON.parse(localStorage.getItem('ClosedIds'));
      }
      this.initChildsMenus();
      this.initBreadData();
      this.getNotice();
    });
  },
  computed: {
    backUrl () {
      if (this.breadData.length > 1) {
        return this.breadData[this.breadData.length - 2].Url;
      }
      return '';
    },
    showBreadMenu () {
      return this.breadData.length > 1 &&
      (this.currentMenuLen >= 3 ||
      (this.currentMenuTree.length > this.currentMenuLen));
    },
    allMenuList () {
      return this.$store.state.menuList;
    },
    isMinSize () {
      return this.$store.getters.getisMinSize;
    },
    currentMenuLen () {
      return this.currentMenu.length;
    },
    currentMenu () {
      return this.$store.getters.getCurrentMenu;
    },
    ParentMenu () {
      var l = this.currentMenu.length;
      var currentMenu = this.currentMenu[l - 2];
      this.$nextTick(() => {
        if (this.currentMenuLen == 4) { this.$refs.topParentMenu.updateActiveName(currentMenu); }
      });
      return currentMenu;
    },
    showpaddingTop () {
      let top = 0;

      if (this.showBreadMenu) {
        top += 40;
      } else if (this.currentMenuLen >= 3) {
        top += 40;
      }
      if (this.currentMenuLen == 4) {
        top += 44;
      }
      return top + 'px';
    },
    menuMarginLeft () {
      if (this.isMinSize) {
        return 60 + 'px';
      } else {
        return 180 + 'px';
      }
    },
    ...mapState(['currentMenuTree'])
  },
  watch: {
    currentMenu (newval) {
      this.initChildsMenus();
    },
    currentMenuTree (newVal) {
      this.initBreadData();
    }
  },
  mounted () {
    window.resize = this.pageHeight;
    setTimeout(() => {
      this.pageHeight();
    }, 2000);
    setInterval(this.nextText, 5000); 
  },
  methods: {
    initAlertNotice() {
      this.ClosedIds = JSON.parse(localStorage.getItem('ClosedIds'));
      if(!this.ClosedIds) 
        this.alertNotice = this.alertData
      else
        this.alertNotice =  this.alertData.filter(e=> this.ClosedIds.indexOf(e.PlatformNoticeId) < 0)
    },
    // 页面高度
    pageHeight () {
      if (
        this.showBreadMenu ||
        (!this.showBreadMenu && this.currentMenuLen >= 3)
      ) {
        this.$refs.pageContent.$el.style.height =
          this.$refs.page.clientHeight - this.alertData.length * 48 - 42 + 'px';
      } else {
        this.$refs.pageContent.$el.style.height =
          this.$refs.page.clientHeight - this.alertData.length * 48 + 'px';
      }
    },
    // 关闭通知
    delNotice (item) {
      // this.ClosedIds
      let arr = JSON.parse(localStorage.getItem('ClosedIds')) || [];
      arr.push(item.PlatformNoticeId);
      localStorage.setItem('ClosedIds', JSON.stringify(arr));
      this.ClosedIds = arr;
      this.pageHeight();
      this.initAlertNotice()
    },
    // 日期处理 2019-07-11 00:00:00
    handleDate (dateStr) {
      let dateArr = dateStr.split(' ')[0];
      let timeArr = dateStr.split(' ')[1];
      let ymd = dateArr.split('-').map(x => parseInt(x));
      let hms = timeArr.split(':').map(x => parseInt(x));
      let today = new Date(ymd[0], ymd[1] - 1, ymd[2], hms[0], hms[1], hms[2]);
      return today;
    },
    getNotice () {
      this.apiServer.homePage
        ._platformNotice({
          IsRead: false,
          ShowType: 1,
          Start: 0,
          Length: 9999
        })
        .then(res => {
          if (res.code == 500) {
            this.$Message.warning(res.message);
          } else {
            this.alertData = res.DataList
            this.initAlertNotice()
            // this.data = res
            //   ? res.DataList.filter(x => {
            //     let today = new Date();
            //     if (!x.NoticeStartTime || !x.NoticeEndTime) {
            //       return true;
            //     }
            //     return (
            //       this.handleDate(x.NoticeStartTime) <= today &&
            //         today <= this.handleDate(x.NoticeEndTime)
            //     );
            //   })
            //   : [];
            // console.log(self.ClosedIds);
            // this.data.forEach(x => {
            //   if (this.ClosedIds.findIndex(f => f == x.PlatformNoticeId) < 0) {
            //     this.noticeDetail(x.PlatformNoticeId);
            //   }
            // });
          }
        });
    },
    // 通知详情
    noticeDetail (id) {
      this.apiServer.homePage
        ._platformNoticeDetial({
          id: id
        })
        .then(res => {
          if (res.code == 500) {
            this.$Message.warning(res.message);
          } else {
            this.alertData.push(res);
          }
        });
    },
    back () {
      if (this.backUrl.length) {
        this.$router.go(-1);
      }
    },
    goToLink (url) {
      this.$router.push(url);
    },
    initBreadData () {
      var breads = this.$store.state.currentMenuTree.map(i => {
        return {
          Url: i.Url,
          Name: i.Name || i,
          ElementId: i.ElementId
        };
      });
      if (breads.length) {
        var end_breads = breads[breads.length - 1];
        end_breads.Url = null;
      }
      this.breadData = breads;
    },
    initChildsMenus () {
      this.$refs.myAside.tiggerMenuActive(this.currentMenu);
      if (this.currentMenuLen > 2) {
        var data = this.$store.getters.getMenuInfo(this.currentMenu[1]);
        this.threeLevelMenu = data;
      } else this.threeLevelMenu = {};

      if (this.currentMenuLen > 3) {
        this.fourLevelMenu = this.$store.getters.getMenuInfo(
          this.currentMenu[2]
        );
      } else this.fourLevelMenu = {};

      this.tiggerActiveMenu();
    },
    tiggerActiveMenu () {
      var l = this.currentMenu.length;
      var currentMenu = this.currentMenu[l - 1];
      this.activeMenu = currentMenu;
      this.$nextTick(() => {
        if (this.currentMenuLen == 3 && this.$refs.topParentMenu) { this.$refs.topParentMenu.updateActiveName(currentMenu); } else if (this.currentMenuLen == 4 && this.$refs.MidChildMenu) {
          this.$refs.MidChildMenu.updateActiveName(currentMenu);
        }
      });

      setTimeout(() => {

      }, 0);
    },
    scroll(){
      var lineHeight = 24
      var lineCount = this.options.lenght
      //滚动到显示区域底部时 数组累加
      if(Math.abs(this.marginTop) >= (lineHeight*lineCount)-lineHeight*4){
        // this.marginTop = 0
        this.options = this.options.contact(this.options)
      }else{
        this.marginTop -= lineHeight
      }
      document.getElementById('mesBox').style.top = this.marginTop + 'px'
    },
    nextText() {
      if (!this.alertNotice || !this.alertNotice.length)
        this.currentTextIndex = 0
      else
        this.currentTextIndex = (this.currentTextIndex + 1) % this.alertNotice.length;
    },
    jumpTo(item) {
      if(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/.test(item.JumpUrl)) {
        window.open(item.JumpUrl);
      } else {
        // this.$Message.warning('跳转路径不合法！');
      }
    }
  },
  components: {
    myAside: myAside
  }
};
</script>

<style lang="scss" scoped>
.myAside {
  position: fixed;
  left: 0px;
  top: 50px;
  bottom: 0px;
  z-index: 99;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  background: #292929;
}

.myfoot {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 99;
  min-width: 1000px;
}

.content {
  position: relative;
  min-width: 824px;
}

.page {
  height: 100%;
  position: relative;

  &.showBreadMenu {
    padding-top: 40px;
    box-sizing: border-box;
  }

  .topParentMenu {
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #fff;
    font-size: 14px;
    font-weight: 400;
    position: absolute;
    box-shadow: 0px 1px 6px #ddd;
    top: 0;
    z-index: 10;

    .reBtn {
      height: 100%;
      width: 120px;
      line-height: 40px;
      text-align: center;
      align-self: center;
      color: #44526e;
      border-right: 1px solid #dddddd;
      margin-right: 20px;
      cursor: pointer;

      i {
        padding-right: 5px;
      }
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
      height: 40px;
      line-height: 40px;
      padding: 0px;
      margin: 0 20px;
    }

    .ivu-menu-horizontal {
      height: 40px;
      line-height: 40px;
    }

    .ivu-menu-horizontal.ivu-menu-light:after {
      content: "";
      display: block;
      width: 100%;
      height: 0px;
      background: #d0d0d0;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .MidChildMenu {
    width: 100%;
    height: 34px;
    display: flex;
    position: absolute;
    background-color: none;
    font-size: 14px;
    font-weight: 400;
    top: 40px;
    color: #666666;
    margin: 10px 0;

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
      height: 30px;
      line-height: 30px;
      padding: 0 20px;
      color: #666;
      transition: none;
    }

    .ivu-menu-horizontal {
      height: 34px;
      line-height: 34px;
      padding: 2px;
      margin: 0 auto;
      border-radius: 17px;
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
      color: #fff;
      background-color: #ff5858;
      border-radius: 17px;
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover {
      color: #fff;
      background-color: #ff5858;
      border-radius: 17px;
    }

    .ivu-menu-horizontal.ivu-menu-light:after {
      content: "";
      display: block;
      width: 100%;
      height: 0px;
      background: #d0d0d0;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .topMenu {
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #fff;
    position: absolute;
    top: 0;
    box-shadow: 0px 1px 6px #ddd;

    .reBtn {
      height: 100%;
      width: 120px;
      line-height: 40px;
      text-align: center;
      align-self: center;
      color: #44526e;
      border-right: 1px solid #dddddd;
      margin-right: 20px;
      cursor: pointer;

      i {
        padding-right: 5px;
      }
    }

    ::v-deep  .bread {
      flex: 1;
      align-self: center;
      color: #666666;

      > span {
        padding-left: 5px;

        &:last-child {
          color: #ff5858;
        }
      }

      span {
        a {
          color: #666666;
        }
      }
    }
  }

  .router {
    padding: 10px 10px 10px 10px;
  }
  .hasNotice {
    height: calc(100% - 44px);
  }
  .inlineInner {
    display: inline;
    ::v-deep  p,
    div,
    h3 {
      display: inline !important;
    }
  }
}

.top-tipcontainer {
  height: 36px;
  overflow: hidden;     /* 隐藏溢出的内容 */
  padding: 10px 2px;
  background: #f7ebc5dd;
  position: absolute;
  z-index: 999999;
  top: 5px;
  left: 5px;
  right: 5px;
  opacity: 1;
  display: flex;
  align-items: center;
  border-radius: 2px;
  .text {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    .inlineInner {
      flex: 1;
      width: auto;
      white-space: nowrap;  /* 禁止换行 */
      overflow: hidden;     /* 隐藏溢出的内容 */
      text-overflow: ellipsis; /* 使用省略号表示被裁切的文本 */
    }
    .tip-close {
      color:#ff5858;
      cursor:pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/page.vue